// Copyright (C) 2021 TANNER AG

import gql from "graphql-tag";

export const FullTSChapterFragment = gql`
    fragment FullTSChapterFragment on EMobilityChapter {
        id
        title
        slug
        intro
        order
        eMobilityContents {
            order
            title
            content
            table
            quote
            info
            assetWithDescriptions(orderBy: sortIndex_ASC) {
                id
                asset(locales: [$lang, de]) {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }

                description
                localizedAsset {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }
            }
            image(locales: [$lang, de]) {
                handle
                fileName
                width
                height
                url
                mimeType
            }
            hotspots(orderBy: sortIndex_ASC) {
                posX
                posY
                headline
                description
            }
            twoColumns
            youTubeLink
        }
        tSTopic {
            id
            slug
            title
            order
            intro
            tsChapters(orderBy: order_ASC) {
                id
                slug
                order
                title
            }
        }
    }
`;

export default gql`
    query TSChapter($slug: String!, $lang: Locale!, $stage: Stage!) {
        eMobilityChapter(where: { slug: $slug }, locales: [$lang], stage: $stage) {
            ...FullTSChapterFragment
        }
    }
    ${FullTSChapterFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/tSChapter.js